let formSubmit = document.querySelector('form.contact button[type=submit]');
let grecaptchaPublicKey = document.querySelector('meta[name="grecaptchaPublicKey"]');
grecaptchaPublicKey = (grecaptchaPublicKey)?grecaptchaPublicKey.getAttribute('content'):grecaptchaPublicKey;

formSubmit && grecaptchaPublicKey && formSubmit.addEventListener('click', function(event) {
    event.preventDefault();
    let form = document.querySelector('form');

    if(form.checkValidity()) {
        if(document.querySelector('.response')) {
            grecaptcha.ready(() => {
                // Public API Key
                grecaptcha.execute(grecaptchaPublicKey, {
                    action: 'submit'
                }).then(token => {
                    document.querySelector('.response').value = token;
                    form.submit();
                });
            });
        } else {
            console.error('Input Response is missing');
        }
    } else {
        form.classList.add('was-validated');
		console.log('invalid');
    }
});